import { AuthService } from '../../../auth/auth.service';
import { Navigate } from 'react-router-dom';
import React from 'react';

export function SignOut() {
  AuthService.signOut();
  return (<Navigate to="/"/>)
}